import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { TestCarPageAdapter } from '@modules/content-api/adapter/test-car-page-adapter';
import { ContentAPIService } from '@modules/content-api/content-api.service';

const TEST_CAR_PAGE_PARAMS = new HttpParams().appendAll({
  include: ['test_cars', 'test_cars.image', 'test_cars.document.file'].join(),
});

@Injectable({
  providedIn: 'root',
})
export class TestCarPageService {
  private apiService = inject(ContentAPIService);
  private testCarPageAdapter = inject(TestCarPageAdapter);

  public getTestCarPage(testCarId: any) {
    return this.apiService.getResource('test_cars_sections', testCarId, TEST_CAR_PAGE_PARAMS).pipe(
      map((data) => {
        try {
          return this.testCarPageAdapter.parse(data ?? null);
        } catch (error) {
          console.error(error);
          return null;
        }
      })
    );
  }
}
